<template>
	<v-dialog v-model="dialogVisible" @click:outside="outsideClicked" max-width="800px" :height="dialogHeight">



		<span @click="closeDialog" class="auth-dialog__close-btn pointer pa-2 align-self-end dialog-action-element close-btn">
			<v-icon>mdi-close</v-icon>
		</span>



		<div class="w-100 rounded-16 rounded-lg-20 overflow-hidden h-100">
			<v-row no-gutters class="d-flex flex-row justify-space-between h-100">

				<v-col cols="12" sm="5" v-if="!isMobileDevice">
					<LeftColumn />
				</v-col>



				<v-col cols="12" sm="7" class="h-100">
					<RightColumn />
				</v-col>

			</v-row>
		</div>
	</v-dialog>
</template>



<script setup>

import { isMobile } from '@/utils/utils';
import authEvents from '@/Events/AuthDialog';
import { useAuthStore } from "@/store/AuthStore";
import { computed, onMounted, onUnmounted } from 'vue';
import LeftColumn from '@/components/Auth/AuthDialog/Elements/LeftColumn.vue';
import RightColumn from '@/components/Auth/AuthDialog/Elements/RightColumn.vue';

const authStore = useAuthStore();
const isMobileDevice = isMobile();

const dialogVisible = computed({
	get() {
		return authStore.loginDialogVisible;
	},
	set(value) {
		authStore.setLoginDialogVisible(value);
	},
});


const dialogHeight = computed(() => {
	return isMobileDevice.value ? '650px' : '710px';
});


const closeDialog = () => {
	dialogVisible.value = false;
};

const outsideClicked = () => {
	closeDialog();
};

const openDialog = () => {
	dialogVisible.value = true;
};


onMounted(() => {
	authEvents.on('open-auth-dialog', openDialog);
	authEvents.on('close-auth-dialog', closeDialog);
});

onUnmounted(() => {
	authEvents.off('open-auth-dialog', openDialog);
	authEvents.off('close-auth-dialog', closeDialog);
});

</script>



<style scoped lang="scss">
@use '@/assets/scss/utilities/_background.scss' as background;
</style>